import { apiFetch } from './api';

export interface ChatMessage {
	role: 'user' | 'assistant' | 'system';
	content: string;
}

export interface AgentChatRequest {
	message: string;
	conversationHistory?: ChatMessage[];
}

export interface AgentChatResponse {
	response: string;
	toolsUsed: string[];
	guardrailFlags: string[];
}

export interface AgentChatError {
	error: string;
	message: string;
}

export async function sendAgentMessage(
	baseUrl: string,
	token: string,
	request: AgentChatRequest
): Promise<AgentChatResponse> {
	const res = await apiFetch(`${baseUrl}/api/v1/agent/chat`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify(request),
	});

	if (!res.ok) {
		const errorBody: AgentChatError = await res.json().catch(() => ({
			error: `HTTP ${res.status}`,
			message: `Request failed with status ${res.status}`,
		}));
		throw new Error(errorBody.message || `HTTP ${res.status}`);
	}

	return res.json();
}
